import { RouterName } from "shared/RouterName";
import {
  HomePage,
  ProductCategories,
  ProductDetail,
  TableCartPage,
  InformationCartPage,
  CartCompletePage,
  LoginPage,
  CartSuccessPage,
  ReturnPoliciesPage,
  DeliveryAndPaymentPage,
} from "../pages";

export const publicRoutesName = [
  {
    key: "key",
    path: "/",
    exact: true,
    component: HomePage,
  },
  {
    key: "category",
    path: `${RouterName.Products.category.url}/:${RouterName.Products.category.key}`,
    exact: true,
    component: ProductCategories,
  },
  {
    key: "search",
    path: `${RouterName.Products.search.url}/:${RouterName.Products.search.key}`,
    exact: true,
    component: ProductCategories,
  },
  {
    key: "search",
    path: `${RouterName.Products.sale.url}/:${RouterName.Products.sale.key}`,
    exact: true,
    component: ProductCategories,
  },
  {
    key: "key",
    path: "/product-detail/:id",
    exact: true,
    component: ProductDetail,
  },
  {
    key: "cart",
    path: `${RouterName.Payment.Cart.url}`,
    exact: true,
    component: TableCartPage,
  },
  {
    key: "checkout",
    path: `${RouterName.Payment.Checkout.url}`,
    exact: true,
    component: InformationCartPage,
  },
  {
    key: "completed",
    path: `${RouterName.Payment.Completed.url}`,
    exact: true,
    component: CartCompletePage,
  },
  {
    key: "success",
    path: `${RouterName.Payment.Success.url}/:${RouterName.Payment.Success.key}`,
    exact: true,
    component: CartSuccessPage,
  },
  {
    key: "key",
    path: "/auth/login",
    exact: true,
    component: LoginPage,
  },
  {
    key: "ReturnPolicies",
    path: RouterName.ReturnPolicies.url,
    exact: true,
    component: ReturnPoliciesPage,
  },
  {
    key: "DeliveryAndPayment",
    path: RouterName.DeliveryAndPayment.url,
    exact: true,
    component: DeliveryAndPaymentPage,
  },
];
